// The lobby's parade under the medsnapp look (3 Nov 2026): three or four of MedSnapp's cast, Bleep first (it starts every
// battle), gently idle beside the "medics in the lobby" figure. Renders nothing in any other look.
import { useLook } from '@/look';
import { CastMascot } from './CastMascot';
import { LOBBY_PARADE } from './cast';

export function CastParade({ size, count = LOBBY_PARADE.length, className = '' }: { size: number; count?: number; className?: string }) {
  const { look } = useLook();
  if (look !== 'medsnapp') return null;
  return (
    <div data-part="cast-parade" aria-hidden="true" className={`flex items-end gap-2 ${className}`}>
      {LOBBY_PARADE.slice(0, count).map((name) => <CastMascot key={name} name={name} mood="idle" size={size} />)}
    </div>
  );
}
